import { SelectorOptionProps } from "@client/ui";

export const HEIGHTS = {
  footer: 100,
  navBar: 60,
};
export enum ColorEnum {
  Blue = "#144CC3",
}

export const HomeDeliveryTypeDropdownList: SelectorOptionProps[] = [
  {
    label: "One way delivery",
    value: "",
    showInfo: true,
    infoContent: "this the content about the delivtion optin",
  },
  {
    label: "Double way delivery",
    value: "",
    showInfo: true,
    infoContent: "this the content about the delivtion optin",
  },
];

export const NairaSign = "₦";

export const ICON_NAMES = {
  SuccessBlue: "blue_success",
};

export const COLORS = {
  Blue: "#144CC3",
  Grey100: "#C1C1C1",
  Grey86: "#D9DBDC",
  Grey20: "#333333",
  StatusGrey: "#949494",
  StatusRed: "#A62408",
  StatusBlue: "#3091F2",
  BlueLight: "#43BCD1",
  RedLight: "#EA542E",
  YellowLight: "#F7D277",
  StatusGreen: "#08A657",
  GreyMediumDark: "#616161",
};
export const SERVICES = [
  // {
  //   title: "TapRide",
  //   description: "Instant rides at your fingertips",
  //   imgUrl: "/image/service-ride.jpg",
  //   path: "/ride",
  // },
  // {
  //   title: "TapDelivery",
  //   description: "Meals delivered in 30 minutes or less",
  //   imgUrl: "/image/service-food.jpg",
  //   path: "/food-delivery",
  // },
  // {
  //   title: "TapPartner",
  //   description: "Grow your restaurant business with us",
  //   imgUrl: "/image/service-partner.jpg",
  //   path: "/partner",
  // },
  // {
  //   title: "TapGrocer",
  //   description: "Fresh groceries in 1 hour",
  //   imgUrl: "/image/service-groceries.jpg",
  //   path: "/groceries",
  // },
  {
    title: "Tap-zus to Ride",
    description: "Tap-us  to order a ride. ",
    imgUrl: "/image/drive-home.jpg",
    path: "/ride",
  },
  {
    title: "Tapzus Driver",
    description: "Drive with Tapzus and earn more.",
    imgUrl: "/image/drive-home.jpg",
    path: "/driver/info",
  },
  {
    title: "Home delivery",
    description: "Fast and reliable delivery service.",
    imgUrl: "/image/delivering.jpg",
    path: "/home-delivery",
  },
  {
    title: "Own a Restaurant ",
    description: "Own a restaurant and get more customers.",
    imgUrl: "/image/restaurant-home.jpg",
    path: "/food-delivery",
  },
  {
    title: "Grocery Delivery",
    description: "Convenient grocery delivery to your doorstep.",
    imgUrl: "/image/grocery.jpg",
    path: "/grocery-delivery",
  },

  {
    title: "A business",
    description: " We help you grow your business.",
    imgUrl: "/image/business-home.png",
    path: "/business",
  },
];

export const COMPANY = {
  name: "Tapzus",
  address: "Lagos, Nigeria",
  email: "info@tapzus.com",
  phoneNumber: "+234 123 456 7890",
  websiteUrl: "www.tapzus.com",
  logo: "/image/logo.png",
  coverImage: "/image/cover.jpg",
  AboutUs: {
    title: "Redefining Ride-Hailing for a Smarter and  safe Future",
    description:
      "At Tapzus, we believe that transportation should be seamless, reliable, and accessible to everyone. Our goal is to revolutionize the ride-hailing experience by providing safe, efficient, and affordable mobility solutions tailored to your needs.",
    imgUrl: "",
  },
};
